import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db } from "firebase/fbConfig.js"
import moment from 'moment'
import { Link } from 'react-router-dom'

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Search from "@material-ui/icons/Search";
import Accordion from "components/Accordion/Accordion.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";
import { Grid } from "@material-ui/core";

// Forms
import AssignActionForm from "components/Forms/AssignActionForm.jsx"

// Firebase Redux Integration
import { startSetPendingActionsList } from 'store/actions/actionsActions'
import { tableToFirestoreObjects, updateFirestoreWithTableData, addFieldToDocument } from "store/actions/firestoreActions"
import { startSetList } from "store/actions/adminActions"

const Transition = (props) => {
    return <Slide direction="down" {...props} />
}

class Users extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLoaded: false,
            assignActionModal: false,
            volUID: '',
            username: ''
        };
    }

    handleClickOpen = (modal, volUID) => {
        var x = [];
        x[modal] = true;
        this.setState({
            ...x,
            volUID
        });
    }

    handleClose = (modal) => {
        var x = [];
        x[modal] = false;
        this.setState(x);
    }

    loadData = () => {
        console.log("loading vendor data")
        let data = db.collection(this.props.collection)
            .get().then((snapshot) => {
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        id: doc.id,
                        ...docData
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(docObj => {
                this.setState({
                    data: docObj,
                    dataLoaded: true
                })
            })
    }


    handleChange = (docID) => {
        console.log(docID)
    }

    // filterData = (query, casesData) => {
    //     if (casesData) {
    //       var newArray = casesData.filter(function (el) {
    //         return el.clientFirstName.includes(query)
    //       });
    //       console.log(newArray);
    //           this.setState({
    //             filteredCasesData: newArray,
    //             dataFiltered:
    //           })

    //     } 

    // }

    assignUser = (user) => {
        this.props.onAssignUser(user)
        this.setState({
           userAssigned: true
      })
    }

    render() {
        const { AuthBool, classes, users, displayField, query } = this.props;
        //console.log(lawyers.dataRows)
        const searchButton =
            classes.top +
            " " +
            classes.searchButton;

        if (AuthBool) {
            if (!this.state.dataLoaded) {
                this.loadData()
            }
        }

        let filteredData = []

        if (Array.isArray(this.state.data)) {
            if (this.state.data) {
                var newArray = this.state.data.filter(function (el) {
                    // console.log(el)
                    return el[displayField] && el[displayField].includes(query)
                });
                // console.log(newArray);
                filteredData = newArray
            }
        }
        // if(cases) {this.filterData(query, cases.dataRows)}
        // console.log(filteredData.length)
        console.log(this.state)
        return (
            <div>
                {
                    this.state.dataLoaded ? (
                        <div>
                            {(filteredData && !this.state.userAssigned) && filteredData.map(userRow => {
                                // console.log(userRow)
                                return (
                                    <div>
                                        <div
                                            onClick={() => this.assignUser(userRow)}
                                        >
                                            <h5 style={{ color: "black", fontSize: ".9rem" }}><b>{userRow[this.props.displayField]}</b></h5>

                                        </div>
                                    </div>
                                )
                            })}
                            
                        </div>
                    ) : (
                            <p className={classes.cardSubtitle}>Loading...</p>
                        )
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        AuthBool: !!state.auth.user,
        users: state.admin.list,
        // lawyers: state.lawyers.lawyers,
        // clients: state.clients.clients
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    console.log(ownProps)
    return {
        startSetList: dispatch(startSetList(ownProps.collection)),
        // startSetLawyersList: dispatch(startSetLawyersList(ownProps.uid)),
        // startSetClientsList: dispatch(startSetClientsList(ownProps.uid)),        
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(Users);



// WEBPACK FOOTER //
// ./src/views/Explore/ExploreMapAssignUser.jsx